import axios from "axios";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie"

export default function Console() {
    const [cookies, setCookie, removeCookie] = useCookies(['auth']);
    const [loading, setLoading] = useState(true)
    const remove=(e)=>{
        e.preventDefault()
        removeCookie("auth")
    }

    const [rate, setRate] = useState(null)

    useEffect(()=>{
        const getRate = async()=>{
            const rateData = await axios.get("https://script.google.com/macros/s/AKfycbw3CdF38tRgiwseHL2kGnzZY6yr8AR7NyGP6iGP108GgoOXrE-xLbg4lS2ZHgUaT3eY_A/exec")
            if(rateData.status){
                setRate(rateData.data.rate)
                setLoading(false)
            } 
        }

        getRate()
    },[])

    const rateChange = async(e) =>{
        e.preventDefault();
        const formData = new FormData();
        formData.append("rate",rate)
        // const rateUpdate = await axios.post("https://script.google.com/macros/s/AKfycbw3CdF38tRgiwseHL2kGnzZY6yr8AR7NyGP6iGP108GgoOXrE-xLbg4lS2ZHgUaT3eY_A/exec", formData)
        const rateUpdate = await axios.post("https://script.google.com/macros/s/AKfycbw5g5jZyEEP6r7zx9HzrdPVLtsjOPZ16dZMf-GdDfvAxGnf2AnLS3YMtwR4b625dm0bZw/exec", formData)
        if(rateUpdate.status===200){
            window.location.reload()
        }

        // console.log(rate)
    }

    if(loading){
        return(
            <div>
                <h1 style={{
                    color:"var(--gold)",
                    fontSize:"32px",
                    fontFamily:"var(--f1)"    
                }}>Loading...</h1>
            </div>
        )
    }
    return(
        <div style={{
            height:"100%", 
            padding:"2rem 1rem", 
            display:"flex", 
            flexDirection:"column", 
            justifyContent:"space-between", 
            alignItems:"center"}}>
            <aside style={{
                width:"100%",
                display:"flex",
                justifyContent:"space-between",
                alignItems:"center"
            }}>
                <h1 style={{
                    color:"var(--gold)",
                    fontSize:"18px",
                    fontFamily:"var(--f1)"    
                }}>Hi, Admin</h1>
            </aside>
            <form
                onSubmit={rateChange} 
                style={{
                    width:"100%",
                    maxWidth:"350px",
                    display:"flex", 
                    flexDirection:"column",
                    gap:"1rem",
                    alignItems:"flex-end"}}>
                <div style={{
                    width:"100%",
                    display:"flex",
                    flexDirection:"column",
                    gap:"1rem"
                }}>
                    <label style={{color:"var(--gold)"}}>Update Gold Rate</label>
                    <input 
                        className="btn goldBtn" 
                        type="number"
                        value={rate}
                        onChange={(e)=>setRate(e.target.value)}
                    />
                </div>
                <div>
                    <input className="btn goldBtn" type="submit" value={"Submit"}/>
                </div>
            </form>
            {/* <p>Current Rate:{rate}</p> */}
            <button className="btn goldBtn" style={{marginLeft:"auto"}} onClick={(e)=>{remove(e)}}>Sign out</button>
        </div>
    )
}